/**
 * @description 全网拓扑 networkTopology
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const networkTopologyBiz = new Logic()

networkTopologyBiz.getTopology = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.getTopology,
    data: data
  })
}

networkTopologyBiz.saveTopology = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.saveTopology,
    data: data
  })
}

networkTopologyBiz.getDefaultTopo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.getDefaultTopo,
    data: data
  })
}

networkTopologyBiz.getHostTopo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.getHostTopo,
    data: data
  })
}

networkTopologyBiz.saveDefaultPic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.saveDefaultPic,
    data: data
  })
}

networkTopologyBiz.saveGroupPic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.saveGroupPic,
    data: data
  })
}

networkTopologyBiz.createDefault = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.createDefault,
    data: data
  })
}

networkTopologyBiz.deleteApp = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.deleteApp,
    data: data
  })
}

networkTopologyBiz.getNewTopology = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.getNewTopology,
    data: data
  })
}

networkTopologyBiz.getAlarmStatistics = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.getAlarmStatistics,
    data: data
  })
}

networkTopologyBiz.saveNewTopology = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.networkTopology.saveNewTopology,
    data: data
  })
}

export default networkTopologyBiz
